import isString from 'lodash-es/isString';
import isUndefined from 'lodash-es/isUndefined';
import { RefObject, useLayoutEffect } from 'react';

export function useAttribute(elementRef: RefObject<Element>, name: string, value: string | undefined) {
  // We can't use element refs as a dependency, so run the effect after every update.
  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }

    // Compare the provided value to the current value, and update the attribute only if needed.
    const currentValue = element.getAttribute(name);
    if (isUndefined(value)) {
      if (isString(currentValue)) {
        element.removeAttribute(name);
      }
    } else if (currentValue !== value) {
      element.setAttribute(name, value);
    }
  });
}
